<div class="row">
  <div *ngIf="status==1 " class="text-lg-center">
    <ngb-alert [dismissible]="false" [type]="'success'"><i class="feather icon-thumbs-up"></i>{{"Operation is approved"
      | uppercase}}</ngb-alert>
  </div>
  <div *ngIf="status==2 " class="text-lg-center">
    <ngb-alert [dismissible]="false" [type]="'danger'"><i class="feather icon-thumbs-down"></i> {{"Operation is
      rejected" | uppercase}}</ngb-alert>
  </div>
</div>
<form  (ngSubmit)="merchantSubmit(merchantBasic.value)" [formGroup]="merchantBasic">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <!--          <div class="row">-->
          <div class="mb-3 col-md-12">
            <!-- <div class="mb-3"> -->

            <!-- <label class="form-label">Merchant ID</label> -->
            <label for="MerchantID" class="col-form-label">Entity ID <span aria-hidden="true" class="symbol required"
                style="color:red;">*</span></label>
            <ng-select formControlName="MerchantID" (click)="midSubmit()" (keyup.enter)="midSubmit()"
              placeholder="merchantId" id="MerchantID">
              <ng-option id="selectedOption" *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                {{merchant.merchant_name}} ({{merchant.MerchantId}})
              </ng-option>
            </ng-select>
            <!-- </div> -->
          </div>

          <div class="mb-3 col-md-4">
            <label for="autoRefund" class="col-form-label">Auto Refund <span aria-hidden="true" class="symbol required"
                style="color:red;">*</span></label>
            <select class="form-select" id="autoRefund" formControlName="autoRefund"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.autoRefund.errors}" (change)="resetAutorefund($event)"
              (focus)="fun('autoRefund')" (focusout)="funover('autoRefund')">
              <option value=null disabled>Select Auto Refund</option>
              <option ngValue="1">Yes</option>
              <option ngValue="0">No</option>
            </select>
          </div>

          <div class="mb-3 col-md-4">
            <label for="autoRefundHours" class="col-form-label">Hours</label>
            <select class="form-select" id="autoRefundHours" formControlName="autoRefundHours"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.autoRefundHours.errors}" (click)="resetHours()"
              (focus)="fun('autoRefundHours')" (focusout)="funover('autoRefundHours')">
              
              <option value=null disabled>Select Hours</option>
              <option>00</option>
              <option>01</option>
              <option>02</option>
              <option>03</option>
              <option>04</option>
              <option>05</option>
              <option>06</option>
              <option>07</option>
              <option>08</option>
              <option>09</option>
              <option>10</option>
              <option>11</option>
              <option>12</option>
              <option>13</option>
              <option>14</option>
              <option>15</option>
              <option>16</option>
              <option>17</option>
              <option>18</option>
              <option>19</option>
              <option>20</option>
              <option>21</option>
              <option>22</option>
              <option>23</option>

            </select>
          
          </div>
          <div class="mb-3 col-md-4">
            <label for="autoRefundMin" class="col-form-label">Minutes</label>
            <select [disabled]="!(merchantBasic.controls['autoRefund'].value)" class="form-select" id="autoRefundMin"
              formControlName="autoRefundMin" [ngClass]="{'is-invalid': isForm6Submitted && form6.autoRefundMin.errors}"
              (click)="resetMinutes()" (focus)="fun('autoRefundMin')" (focusout)="funover('autoRefundMin')">
              <option value=null disabled>Select Minutes</option>
              <option>00</option>
              <option>05
              </option>
              <option>10</option>
              <option>15
              </option>
              <option>20</option>
              <option>25
              </option>
              <option>30</option>
              <option>35
              </option>
              <option>40</option>
              <option>45
              </option>
              <option>50</option>
              <option>55</option>

            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>
          <div class="mb-3 col-md-4">
            <label for="pushUrl" class="col-form-label">Push URL <span aria-hidden="true" class="symbol required"
                style="color:red;">*</span></label>
            <select class="form-select" id="pushUrl" formControlName="pushUrl"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.pushUrl.errors}" (change)="pushData()"
              (focus)="fun('pushUrl')" (focusout)="funover('pushUrl')">
              <option value=null disabled>Select Push URL</option>
              <option value="1">Yes</option>
              <option value="0">No</option>

            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>
          <div class="mb-3 col-md-4">
            <label for="enterpushUrl" class="col-form-label">Enter Push URL </label>
            <input class="form-control" [readonly]="pushURLvalue" type="text" autocomplete="new-password"
              formControlName="enterpushUrl" placeholder="Enter Push URL" id="enterpushUrl" maxlength="100"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.enterpushUrl.errors}" (focus)="fun('enterpushUrl')"
              (focusout)="funover('enterpushUrl')" />

              <div *ngIf="!datadisplay" class="text-danger mt-1">
                Please enter proper url
              </div>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>

          <div class="mb-3 col-md-4">
            <label for="settlementUrl" class="col-form-label">Settlement cycle <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            <select class="form-select" id="settlementUrl" formControlName="settlementUrl"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.settlementUrl.errors}" (focus)="fun('settlementUrl')"
              (focusout)="funover('settlementUrl')">
              <option value=null disabled>Select Settlement cycle</option>
              <option value="T+0">T+0</option>
              <option value="T+1">T+1</option>
              <option value="T+2">T+2</option>
              <option value="T+3">T+3</option>
              <option value="T+4">T+4</option>
              <option value="T+5">T+5</option>

            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>

          <div class="mb-3 col-md-4">
            <label for="exampleInputUsername1" class="col-form-label">Integration type <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            <select class="form-select" id="integrationType" formControlName="integrationType"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.integrationType.errors}"
              (focus)="fun('integrationType')" (focusout)="funover('integrationType')">
              <option value=null disabled>Select Integration type</option>
              <option value="0">Direct</option>
              <option value="1">Redirect</option>

            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>
          <div class="mb-3 col-md-4">
            <label for="exampleInputUsername1" class="col-form-label">Payment retry <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>

            <select class="form-select" id="paymentRetry" formControlName="paymentRetry"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.pushUrl.errors}" (focus)="fun('paymentRetry')"
              (focusout)="funover('paymentRetry')">
              <option value=null disabled>Select Payment Retry</option>
              <option value="1" selected>Yes</option>
              <option value="0">No</option>

            </select>


          </div>
          <div class="mb-3 col-md-4">
            <label for="linkPaymentEmail" class="col-form-label">Link based payment Email <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            <!-- <input class="form-control" type="text" autocomplete="new-password"
                #requried="" required /> -->
            <select formControlName="linkPaymentEmail" placeholder="Link based payment Email" id="linkPaymentEmail"
              name="requried" class="form-select"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.linkPaymentEmail.errors}"
              (focus)="fun('linkPaymentEmail')" (focusout)="funover('linkPaymentEmail')">
              <option value=null disabled>Select Link based payment Email</option>
              <option ngValue="1">Yes</option>
              <option ngValue="0">No</option>
            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>
          <div class="mb-3 col-md-4">
            <label for="exampleInputUsername1" class="col-form-label">Link based payment SMS <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            <!-- <input class="form-control" type="text" autocomplete="new-password"
                #requried="" required /> -->
            <select formControlName="linkPaymentSms" placeholder="Link based payment SMS" id="linkPaymentSms"
              name="requried" class="form-select"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.linkPaymentSms.errors}"
              (focus)="fun('linkPaymentSms')" (focusout)="funover('linkPaymentSms')">
              <option value=null disabled>Select Link based payment SMS</option>
              <option ngValue="1">Yes</option>
              <option ngValue="0">No</option>
            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>
          <div class="mb-3 col-md-4">
            <label for="exampleInputUsername1" class="col-form-label">Invoice mail remainder? <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            <!-- <input class="form-control" type="text" autocomplete="new-password"
                #requried="" required /> -->
            <select formControlName="invoiceMainReminder" placeholder="Invoice mail remainder?" id="invoiceMainReminder"
              name="requried" class="form-select"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.invoiceMainReminder.errors}"
              (focus)="fun('invoiceMainReminder')" (focusout)="funover('invoiceMainReminder')">
              <option value=null disabled>Select Invoice mail remainder</option>
              <option ngValue="1">Yes</option>
              <option ngValue="0">No</option>
            </select>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>
          <div class="mb-3 col-md-4">
            <label for="reportingCycle" class="col-form-label">Reporting cycle for Entity<span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            <select formControlName="reportingCycle" placeholder="Reporting cycle for the Entity" id="reportingCycle"
              name="requried" class="form-select"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.reportingCycle.errors}"
              (focus)="fun('reportingCycle')" (focusout)="funover('reportingCycle')">
              <option value=null disabled>Select Reporting cycle for the Entity</option>
              <option>Daily</option>
              <option>Weekly</option>
              <option>Monthly</option>

            </select>
        
          </div>

          <div class="mb-3 col-md-4">
            <label for="disableRefundDashboard" class="col-form-label">Disable refund Dashboard <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span>
            </label>
            <select formControlName="disableRefundDashboard" placeholder="Disable refund Dashboard"
              id="disableRefundDashboard" name="requried" class="form-select"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.disableRefundDashboard.errors}"
              (focus)="fun('disableRefundDashboard')" (focusout)="funover('disableRefundDashboard')">
              <option value=null disabled>Select Disable refund Dashboard</option>
              <option value="1">Enable</option>
              <option value="0">Disable</option>

            </select>
          </div>
          <div class="mb-3 col-md-4">
            <label for="disableRefundApi" class="col-form-label">Disable refund API <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span>
            </label>
            <select formControlName="disableRefundApi" placeholder="Disable refund API" id="disableRefundApi"
              name="requried" class="form-select"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.disableRefundApi.errors}"
              formControlName="disableRefundApi" (focus)="fun('disableRefundApi')"
              (focusout)="funover('disableRefundApi')">
              <option value=null disabled>Select Disable refund API</option>
              <option value="1">Enable</option>
              <option value="0">Disable</option>

            </select>
          </div>

          <div class="mb-3 col-md-4">
            <label for="exampleInputUsername1" class="col-form-label">WPS loader<span aria-hidden="true"
                class="symbol required" style="color:red;">*</span></label>
            

            <select class="form-select" id="paymentRetry" formControlName="upi"
              [ngClass]="{'is-invalid': isForm6Submitted && form6.upi.errors}" (focus)="fun('paymentRetry')"
              (focusout)="funover('paymentRetry')">
              <option value=null disabled>Select WPS loader</option>
              <option value="1" selected>Yes</option>
              <option value="0">No</option>

            </select>


          </div>



          <div class="mb-3 col-md-4" style="display: none;">
            <label for="disableRefundDashboard" class="col-form-label">UPI type
            </label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.Intent.errors}" formControlName="Intent" id="Intent"
                (focus)="fun('Intent')" (focusout)="funover('Intent')">
              <label class="form-check-label" for="Intent">
                Intent
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.Collect.errors}" formControlName="Collect"
                id="Collect" (focus)="fun('Collect')" (focusout)="funover('Collect')">
              <label class="form-check-label" for="Collect">
                Collect
              </label>
            </div>

            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>


          <div class="mb-3 col-md-4">
            <label for="disableRefundDashboard" class="col-form-label">Disable instrument wise refund Dashboard
            </label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.mdDisableRefundCc.errors}"
                formControlName="mdDisableRefundCc" id="Credit" (focus)="fun('Credit')" (focusout)="funover('Credit')">
              <label class="form-check-label" for="Credit">
                Credit Card
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.mdDisableRefundDc.errors}"
                formControlName="mdDisableRefundDc" id="Debit" (focus)="fun('Debit')" (focusout)="funover('Debit')">
              <label class="form-check-label" for="Debit">
                Debit Card
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.mdDisableRefundUpi.errors}"
                formControlName="mdDisableRefundUpi" id="UPI" (focus)="fun('UPI')" (focusout)="funover('UPI')">
              <label class="form-check-label" for="UPI">
                WPS
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.mdDisableRefundNb.errors}"
                formControlName="mdDisableRefundNb" id="Net" (focus)="fun('Net')" (focusout)="funover('Net')">
              <label class="form-check-label" for="Net">
                Net Banking
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.mdDisableRefundWallet.errors}"
                formControlName="mdDisableRefundWallet" id="Wallet" (focus)="fun('Wallet')"
                (focusout)="funover('Wallet')">
              <label class="form-check-label" for="Wallet">
                Wallet
              </label>
            </div>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>

          <div class="mb-3 col-md-4">
            <label for="disableRefundDashboard" class="col-form-label">Disable instrument wise refund API
            </label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.refundApiDisableCc.errors}"
                formControlName="refundApiDisableCc" id="CreditCard">
              <label class="form-check-label" for="CreditCard">
                Credit Card
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.refundApiDisableDc.errors}"
                formControlName="refundApiDisableDc" id="DebitCard">
              <label class="form-check-label" for="DebitCard">
                Debit Card
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.refundApiDisableUpi.errors}"
                formControlName="refundApiDisableUpi" id="UPIBANK">
              <label class="form-check-label" for="UPIBANK">
                WPS
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.refundApiDisableNb.errors}"
                formControlName="refundApiDisableNb" id="NetBanking">
              <label class="form-check-label" for="NetBanking">
                Net Banking
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                [ngClass]="{'is-invalid': isForm6Submitted && form6.refundApiDisableWallet.errors}"
                formControlName="refundApiDisableWallet" id="WalletBank">
              <label class="form-check-label" for="WalletBank">
                Wallet
              </label>
            </div>
            <!-- <p class="text-danger mt-1" *ngIf="requried?.errors?.required">required error</p> -->
          </div>

          <!-- <div class="row" *ngIf="status==1||status==2">
            <div class="col-6">
              <label class="form-label">Remarks</label>
              <input type="text" autocomplete="new-password" placeholder="Please add remarks" [disabled]="status != 0" class="form-control"
                formControlName="remarks" id="remarks" />
            </div>
          </div>-->

          <div class="row mb-2" *ngIf="!permissions.includes('Checker Review')">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <!--            <div class="text-end" style="margin-right: 2%;">-->
              <button class="form-control btn btn-primary mt-3"
                [disabled]="!(this.permissions.includes('Add') || this.permissions.includes('Edit'))||this.loading">
                <span id="loading" role="status" aria-hidden="true"></span>
                Submit
              </button>
              <!--            </div>-->
            </div>
          </div>

          <!--<div class="row mb-2" *ngIf="permissions.includes('Checker Review')">
            <div class="col-xs-12">
              <div class="text-center">
                <button class="btn btn-secondary" [disabled]="status != 0" (click)="statusApproval(1)"><i
                    class="feather icon-thumbs-up"></i>Approve
                </button>
                <button class="btn btn-primary" [disabled]="status != 0" (click)="statusApproval(2)">Reject <i
                    class="feather icon-thumbs-down"></i></button>
              </div>
            </div>
          </div>-->
        </div>
        <!-- <div class="mb-3 card-body col-md-2 row" style="margin-top:auto ;margin-bottom: auto;">
            <input class="form-control btn btn-primary" type="submit" />
        </div> -->
      </div>

    </div>
  </div>
</form>